// Vintelligence returns separate make and model fields while SK Vin Search does not.
// This is just a function to determine if the make and model strings are identical.
// If they are, then just return one of them instead of doubling them up.
export function formatMakeAndModelString(make: string, model: string) : string {
    return (make !== model) ? `${make} ${model}` : make;
}